// This is an auto-generated file. Do not edit it directly — your changes will be overwritten the next time the model configs are generated.

 import type { Notification } from '@pigello/pigello-matrix';


import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutateGenericInstance } from '@/requests/hooks';
import type { ErrorResponse, mutateGenericInstanceProps } from '@/requests/types';
import { mutateGenericInstance } from '@/requests/mutating';

export const mutateNotification = async (
  options: mutateGenericInstanceProps<Notification>
) => {
  return mutateGenericInstance<Notification>({
    ...options,
    modelName: 'notification',
  });
};

export const useMutateNotification = (
  options: UseMutationOptions<Notification, ErrorResponse, unknown, unknown>
) => useMutateGenericInstance<Notification>(mutateNotification, options, 'notification');
